import { Component, OnInit,ElementRef, ViewChild,AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeProcesoService } from 'src/app/service/mae-proceso.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { DetParticipanteE,DetParticipanteM,MovFirmaParticipanteM } from 'src/app/model/det-participante-bean';
import { Console } from 'console';

@Component({
  selector: 'app-dml-firma-mensaje',
  templateUrl: './dml-firma-mensaje.component.html',
  styleUrls: ['./dml-firma-mensaje.component.scss']
})
export class DmlFirmaMensajeComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private utilitarioService:UtilitarioService,
    private maeProcesoService:MaeProcesoService,
    private globalVariablesService: GlobalVariablesService,
  ){

   }

   archivo:string;
   x_titulo:string="Resultado de Firma Digital";
   a_tipo:string;
   x_tipo:string;
   c_constancia:string;
   c_firma:string;
   mensaje:String;
   c_iduser:string;
   Response_confirmacion:Response_dml_bean;
   mostrar_mensaje_ok:boolean=false;
   mostrar_mensaje_carga:boolean=false;
   mostrar_mensaje_error:boolean=false;
   mostrar_boton_ver:boolean=false;
   c_participante:String;
   titulo_mensaje:string;
   mostrarParticipantesError:boolean=false;

   //para lista
    listParticipantes = new Array<MovFirmaParticipanteM>();
    listParticipantesMostrar = new Array<MovFirmaParticipanteM>();
    enviados:number=0;
    recibidos:number=0;
    correctos:number=0;
   page = 1;
   pageSize = 10;
   headElements = ['Nro','Nombre','Estado Actualizacion'];


  ngOnInit(): void {
    ///:tipo/:id/:tipomensaje/:mensaje
    //this.pageRefresh();//recuperar parametro
    this.route.params.subscribe((params: Params) => {
      //console.log(params);
      this.a_tipo = params['tipo'];
      this.c_constancia = params['idc'];
      this.c_firma = params['idp'];
      this.archivo  = params['archivo'];
      this.c_iduser = this.globalVariablesService.getC_usuario();
      console.log(this.c_iduser);

      if(this.a_tipo==='a')
        this.x_tipo = 'Alumnos';
      else
        this.x_tipo = 'Profesores';

      if(this.archivo==='0')
      {
        this.titulo_mensaje='Error de firma';
        this.mostrar_mensaje_error = true;
        this.mensaje='Hubo un error al subir el archivo de firma, vuelva a intenarlo.';
      }
      else
      {
        this.titulo_mensaje='Verificando';
        this.mensaje='Se esta recuperando los participantes de la firma realizada, espere un momento';
        // se comienza a cargar el resultado al back
        this.mostrar_mensaje_carga =true;
        this.confirmarRespuestaRec_ini();
      }
    });
  }

  confirmarRespuestaRec_ini()
  {
    this.utilitarioService.loading = true;
    this.maeProcesoService.recuperarfirmado(this.c_constancia,this.c_firma,this.c_iduser,this.archivo).subscribe(data=>{
      if(data.length>0)
      {
        this.listParticipantes = data;
        // se actualiza todos los estados
        this.titulo_mensaje='Actualizando Estados';
        this.mensaje='Se esta actualizando las constancias en los participantes, espere un momento';

        this.enviados=0;
        this.recibidos=0;
        this.confirmarRespuestaRecursivo();
      }
      else
      {
        this.mostrar_mensaje_carga =false;
        this.titulo_mensaje='Error al recuperar recuperar participantes de la firma, pruebe actualizar la pagina.';
        this.mostrar_mensaje_error = true;
        this.utilitarioService.loading = false;
      }

    });
  }
  confirmarRespuestaRecursivo()
  {
    var idfirma = this.listParticipantes[this.enviados].c_firma;
    var ruta = this.listParticipantes[this.enviados].x_ruta;
    this.maeProcesoService.confirmarfirma(idfirma.toString(),ruta.toString(),this.enviados.toString()).subscribe((response_dml_bean:Response_dml_bean)=>{
      console.log(idfirma+'-'+ruta+'-'+this.enviados.toString());
      this.recibidos++;
      console.log(response_dml_bean);

      var nro = 0;
      try{nro = Number(response_dml_bean.codigoRegistroBD);}catch{}

      if(response_dml_bean.codigoRespuestaServicio=="1")
      {
        this.listParticipantes[nro].x_actualizado ='1';
        this.correctos++;
      }
      else
        this.listParticipantes[nro].x_actualizado ='-1';

        console.log(this.listParticipantes[nro]);

      if(this.recibidos==this.listParticipantes.length)
      {
          if(this.correctos==this.listParticipantes.length)
          {
            this.mostrar_mensaje_carga =false;
            this.titulo_mensaje='Correcto';
            this.mostrar_mensaje_ok=true;
            this.mensaje="Se actualizo correctamente todos los participantes";
            this.utilitarioService.toastrSuccess("Se actualizo correctamente todos los participantes");
          }

          else
          {
            this.mostrarParticipantesError = true;

            this.listParticipantesMostrar = this.listParticipantes.filter(x=>x.x_actualizado=='-1' );
            this.mensaje="No se actualizaron todos los participantes, intente individualmente";
            this.utilitarioService.toastrInfo("No se actualizo todos los participantes, prueba con cada uno de manera independiente.");
          }


          this.utilitarioService.loading = false;
      }
      else
      {
        this.enviados++;
        this.confirmarRespuestaRecursivo();
      }
    },
    error=>{
      this.utilitarioService.loading = false;
      console.log(error);
    });
  }

  onActualizarUnitario(participante:MovFirmaParticipanteM)
  {
    this.utilitarioService.loading = true;
    var idfirma = participante.c_firma;
    var ruta = participante.x_ruta;
    // se envia cada uno

    this.maeProcesoService.confirmarfirma(idfirma.toString(),ruta.toString(),"0").subscribe((response_dml_bean:Response_dml_bean)=>{

      if(response_dml_bean.codigoRespuestaServicio=="1")
      {
        participante.x_actualizado ='1';
        this.utilitarioService.toastrSuccess("Se actualizo correctamente el participante");
      }
      else
      {
        participante.x_actualizado ='-1';
        this.utilitarioService.toastrSuccess(response_dml_bean.mensaje);
      }
      this.utilitarioService.loading = false;
    },
    error=>{
      this.utilitarioService.loading = false;
      console.log(error);
    });
  }

  confirmarRespuesta()
  {
    this.utilitarioService.loading = true;

    this.maeProcesoService.recuperarfirmado(this.c_constancia,this.c_firma,this.c_iduser,this.archivo).subscribe(data=>{
      if(data.length>0)
      {
        this.listParticipantes = data;
        // se actualiza todos los estados
        this.titulo_mensaje='Actualizando Estados';
        this.mensaje='Se esta actualizando las constancias en los participantes, espere un momento';

        var i:number;
        this.correctos = 0;
        var cero = 0 as Number;
        for(i = 0;i<this.listParticipantes.length;i++) {


          var idfirma = this.listParticipantes[i].c_firma;
          var ruta = this.listParticipantes[i].x_ruta;
          // se envia cada uno
          this.enviados++;
          this.maeProcesoService.confirmarfirma(idfirma.toString(),ruta.toString(),i.toString()).subscribe((response_dml_bean:Response_dml_bean)=>{
            console.log(idfirma+'-'+ruta+'-'+i.toString());
            this.recibidos++;
            console.log(response_dml_bean);
            var nro = 0;
            try{nro = Number(response_dml_bean.codigoRegistroBD);}catch{}

            if(response_dml_bean.codigoRespuestaServicio=="1")
            {
              this.listParticipantes[nro].x_actualizado ='1';
              this.correctos++;
            }
            else
              this.listParticipantes[nro].x_actualizado ='-1';

              console.log(this.listParticipantes[nro]);

            if(this.recibidos==this.listParticipantes.length)
            {
                if(this.correctos==this.listParticipantes.length)
                {
                  this.mostrar_mensaje_carga =false;
                  this.titulo_mensaje='Correcto';
                  this.mostrar_mensaje_ok=true;
                  this.mensaje="Se actualizo correctamente todos los participantes";
                  this.utilitarioService.toastrSuccess("Se actualizo correctamente todos los participantes");
                }

                else
                {
                  this.mensaje="No se actualizaron todos los participantes, intente individualmente";
                  this.utilitarioService.toastrInfo("No se actualizo todos los participantes, prueba con cada uno de manera independiente.");
                }


                this.utilitarioService.loading = false;
            }
          },
          error=>{
            this.utilitarioService.loading = false;
            console.log(error);
          });

          setTimeout (() => {
          console.log(idfirma+'-'+ruta+'-'+i.toString());
         }, 500);
        }
      }
      else
      {
        this.mostrar_mensaje_carga =false;
        this.titulo_mensaje='Error al recuperar recuperar participantes de la firma, pruebe actualizar la pagina.';
        this.mostrar_mensaje_error = true;
        this.utilitarioService.loading = false;
      }

    });
/*
    const cargaConfirmacionFirma  = this.maeProcesoService.confirmarfirma(this.c_constancia,this.c_firma,this.c_iduser,this.archivo).toPromise()
    .then((response_dml_bean : Response_dml_bean) => {
      console.log(response_dml_bean);

      this.mostrar_mensaje_carga =false;
      if(response_dml_bean.codigoRespuestaServicio=='1')
      {
        this.titulo_mensaje='Correcto';
        this.mostrar_mensaje_ok=true;
        console.log('verde');

        if(this.c_firma!='0')
        {
          this.c_participante = response_dml_bean.codigoRegistroBD;
          this.mostrar_boton_ver = true;
        }
      }
      else
      {
        this.titulo_mensaje='Error al actualizar estados';
        this.mostrar_mensaje_error = true;
        console.log('rojo');
      }
      this.mensaje = response_dml_bean.mensaje;
    });
    Promise.all([cargaConfirmacionFirma])
    .then(response => {
      this.utilitarioService.loading = false;
    });*/
  }
}
